<template>
  <div>
    <el-dialog
      class="editNum"
      title="修改数量"
      :visible.sync="editVisible"
      width="862px"
      :before-close="handleClose"
    >
      <span>请选择修改数量的商品</span>
      <el-table :key="tableKey" v-loading="loading" :data="tableData" style="width: 100%" :cell-class-name="cellName">
        <el-table-column prop="date" label="图片" width="478">
          <template slot-scope="scope">
            <div style="display:flex;">
              <el-image
                style="width: 64px; height: 64px"
                :src="scope.row.FStockImagePath"
                :preview-src-list="[scope.row.FStockImagePath]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
              <div class="goodsName"><span
                @click="toDetail(scope.row,item)"
              >{{ scope.row.FStockName }}</span></div>
            </div>
            <div v-if="scope.row.isEdit" class="editBox">
              <div style="width:70px;">修改数量：</div>
              <!-- οninput="“value=value.replace(/[^0-9.]/g,‘’)”" -->
              <el-input
                v-model="scope.row.editNum"
                size="small"
                placeholder="请输入数量"
                @input="handleOninput(scope.row,scope.row.FQuantyDecimal)"
              />
              <!-- @keyup.native="scope.row.editNum = handleOninput(scope.row.editNum,scope.row.FQuantyDecimal)" -->
              <!-- @input="handleOninput($event,scope.row.FQuantyDecimal)" -->
              <!-- value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1') -->
              <!-- onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/);this.dispatchEvent(new Event('input'))" -->
              <el-button size="small" class="confirm" @click="cfmEdit(scope.row)">确认修改</el-button>
              <el-button size="small" class="close" @click="scope.row.isEdit = false,scope.row.editNum = scope.row.FQuanty,tableKey++">取消</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="单价/数量" width="180">
          <template slot-scope="scope">
            <div v-if="FPriceShow">
              <span class="price" v-html="splitPrice(scope.row.FTotalPrice)" />
              <span style="margin:0 5px;">
                X
              </span>
              <span>
                {{ scope.row.FQuanty }}
                <span v-if="scope.row.FMeasurement">{{ scope.row.FMeasurement }}</span>
              </span>
            </div>
            <div v-else id="noShowPrice">
              <span>￥</span>价格不可见
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button size="small" @click="scope.row.isEdit = true,tableKey++">修改数量</el-button>
            <el-button style="margin:5px 0 0 0;" size="small" @click="dltStock(scope.row,scope.$index)">删除商品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request.js'
export default {
  filters: {

  },
  props: {
    editVisible: {
      type: Boolean
    },
    editList: {
      type: Array,
      default: () => []
    },
    fInfoID: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      tipsVisible: true,
      isEdit: false,
      loading: false,
      fPriceShow: 0,
      tableData: [],
      tableKey: 0
    }
  },
  watch: {
    editVisible: {
      handler(val) {
        if (val) {
          this.isEdit = false
          this.tableData = this.editList
        }
      }
    }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
  },
  methods: {
    handleOninput(row, type) {
      const value = row.editNum
      let str = value
      const len1 = str.substr(0, 1)
      const len2 = str.substr(1, 1)
      // 如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      // 第一位不能是.
      if (len1 == '.') {
        str = ''
      }
      if (len1 == '+') {
        str = ''
      }
      if (len1 == '-') {
        str = ''
      }

      // 限制只能输入一个小数点
      if (str.indexOf('.') != -1) {
        const str_ = str.substr(str.indexOf('.') + 1)
        if (str_.indexOf('.') != -1) {
          str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
        }
      }
      // 正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      if (type == 1) {
        str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1')
      } else if (type == 2) {
        str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
      } else if (type == 3) {
        str = str.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')
      } else if (type == 4) {
        str = str.replace(/^\D*([0-9]\d*\.?\d{0,4})?.*$/, '$1')
      }
      this.$set(row, 'editNum', str)
    },
    cfmDlt() {

    },
    dltStock(row, i) {
      if (this.tableData.length == 1) return this.$message.warning('订单只有一条商品，请使用审批拒绝功能')
      this.$confirm('确认删除明细商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const data = new URLSearchParams()
        const jsonobj = {
          FOrderDetailID: row.FOrderDetailID,
          FBillID: row.FBillID,
          FInfoID: this.fInfoID
        }
        data.append('jsonobj', JSON.stringify(jsonobj))
        request({
          url: '/mall/mallmanage/billapprovalinfo/del',
          method: 'post',
          data
        })
          .then(res => {
            if (res.result) {
              this.isEdit = true
              this.tableData.splice(i, 1)
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }).catch(() => {

      })
    },
    cfmEdit(row) {
      if (!row.editNum || row.editNum == 0) return this.$message.warning('购买数量不能为0!')
      if ((row.editNum * row.FTotalPrice).toFixed(2) == 0) return this.$message.warning('商品金额不能为0')
      if (row.FQuanty == row.editNum) {
        row.isEdit = false
        this.tableKey++
        return
      }
      this.loading = true
      const jsonobj = {
        FQuanty: row.editNum,
        FOrderDetailID: row.FOrderDetailID,
        FInfoID: this.fInfoID
      }
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      request({
        url: '/mall/mallmanage/billapprovalinfo/updateOrderNum',
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            row.FQuanty = row.editNum
            row.isEdit = false
            this.isEdit = true
            this.$emit('renovatePrice')
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    cellName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'noCell'
      }
    },
    splitPrice(val) {
      const str = val ? val.toFixed(2) : '0.00'
      return `￥<span style="font-size:16px;">${str.split('.')[0]}</span>.${str.split('.')[1]}`
    },
    handleClose() {
      this.$emit('closeEdit', this.isEdit)
    },
    confirm() {

    }
  }
}
</script>

<style lang='scss'>
    .editNum {
        .el-dialog {
            border-radius: 6px;

            .el-dialog__header {
                height: 66px;
                position: relative;
                width: 765px;
                margin: auto;
                background-color: #fff;
                border-radius: 6px 6px 0 0;

                .el-dialog__title {
                    height: 26px;
                    line-height: 26px;
                    position: absolute;
                    bottom: 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: bold;
                }

                .el-dialog__headerbtn {
                    top: 24px;
                    right: 0px;
                }

                .el-icon-close {
                    color: #C0C5CF;
                }
            }

            .el-dialog__body {
                padding: 30px 48px;

                .el-table__header-wrapper {
                    display: none;
                }

                .el-table__body-wrapper {
                    max-height: 450px;
                    overflow-y: auto;
                    margin-top: 22px;
                    .el-table__cell {
                        position: relative;
                    }
                    .cell {
                        position: absolute;
                        top: 12px;
                        height: 70px;
                        .editBox {
                            width: 520px;
                            display: flex;
                            margin-top: 20px;
                            height: 32px;
                            line-height: 32px;
                            font-size: 12px;
                            color: #666666;
                            .el-input,.el-input__inner {
                                width: 279px;
                            }
                            .el-button {
                                display: flex;
                                justify-content: center;
                                width: 72px;
                                border-radius: 4px;
                                z-index: 99999;
                            }
                            .confirm {
                                margin-left: 16px;
                                background-color: #EC212D;
                                color: #fff;
                            }
                            .close {
                                border-color: #E6E6E6;
                                background-color: #fff;
                                color: #333333;
                            }
                        }
                        .image-slot {
                            height: 64px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: #f5f7fa;
                        }
                        .price {
                            color: #EC212D;
                            font-weight: bold;
                        }
                        .el-button {
                            width: 84px;
                            background: #FFFFFF;
                            border-radius: 0;
                            border-color: #E6E6E6;
                            color: #333333;
                        }
                    }
                    .noCell {
                        .cell {
                            position: unset;
                            height: auto;
                            overflow: inherit;
                        }
                    }
                    .goodsName {
                        width: 376px;
                        margin-left: 18px;
                        text-align: left;
                        height: 47px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                    #noShowPrice {
                        height: 26px;
                        line-height: 26px;
                        padding: 0 5px;
                        font-size: 14px;
                        color: #ec2631;
                        //   background: #fbd3d5;
                        width: 100px;
                        margin: 0 auto;

                        span {
                            font-size: 12px;
                        }
                    }
                }
            }

            .el-dialog__footer {
                padding: 10px 20px;
            }
        }
    }
</style>
